/* eslint-disable no-case-declarations */
import {
  DELETE_GLOBAL_DESTINATION_SERVICES_SUCCESS,
  DELETE_GLOBAL_INTERNATIONAL_SCHOOLING_SUCCESS,
  DELETE_GLOBAL_LANGUAGE_TRAINING_SUCCESS,
  DELETE_GLOBAL_PROPERTY_MANAGEMENT_HOME_SUCCESS,
  DELETE_GLOBAL_PROPERTY_MANAGEMENT_HOME_TENANT_SUCCESS,
  GET_ASSIGNMENT_EXTENSIONS_SUCCESS,
  GET_ASSIGNMENT_TRIPS_SUCCESS,
  GET_GLOBAL_DESTINATION_SERVICES_SUCCESS,
  GET_GLOBAL_INFO_SUCCESS,
  GET_GLOBAL_INTERNATIONAL_SCHOOLING_SUCCESS,
  GET_GLOBAL_LANGUAGE_TRAINING_SUCCESS,
  GET_GLOBAL_PROPERTY_MANAGEMENT_SUCCESS,
  POST_GLOBAL_DESTINATION_SERVICES_SUCCESS,
  POST_GLOBAL_INFO_SUCCESS,
  POST_GLOBAL_INTERNATIONAL_SCHOOLING_SUCCESS,
  POST_GLOBAL_LANGUAGE_TRAINING_SUCCESS,
  POST_GLOBAL_PROPERTY_MANAGEMENT_HOME_SUCCESS,
  POST_GLOBAL_PROPERTY_MANAGEMENT_HOME_TENANT_SUCCESS,
  PUT_GLOBAL_PROPERTY_MANAGEMENT_HOME_SUCCESS,
  PUT_GLOBAL_PROPERTY_MANAGEMENT_HOME_TENANT_SUCCESS,
  PUT_GLOBAL_PROPERTY_MANAGEMENT_HOST_SUCCESS,
  UPDATE_GLOBAL_DESTINATION_SERVICES_SUCCESS,
  UPDATE_GLOBAL_INFO_SUCCESS,
  UPDATE_GLOBAL_INTERNATIONAL_SCHOOLING_SUCCESS,
  UPDATE_GLOBAL_LANGUAGE_TRAINING_SUCCESS
} from '../types/globalTypes';
import {
  DELETE_TEMPORARY_LIVING_ASSIGNMENT_FAILURE,
  DELETE_TEMPORARY_LIVING_ASSIGNMENT_REQUEST,
  DELETE_TEMPORARY_LIVING_ASSIGNMENT_SUCCESS,
  GET_AUTH_PETS_FAILURE,
  GET_AUTH_PETS_REQUEST,
  GET_AUTH_PETS_SUCCESS,
  GET_TEMPORARY_LIVING_ASSIGNMENT_FAILURE,
  GET_TEMPORARY_LIVING_ASSIGNMENT_REQUEST,
  GET_TEMPORARY_LIVING_ASSIGNMENT_SUCCESS,
  POST_AUTH_PETS_FAILURE,
  POST_AUTH_PETS_REQUEST,
  POST_AUTH_PETS_SUCCESS,
  POST_TEMPORARY_LIVING_ASSIGNMENT_FAILURE,
  POST_TEMPORARY_LIVING_ASSIGNMENT_REQUEST,
  POST_TEMPORARY_LIVING_ASSIGNMENT_SUCCESS,
  UPDATE_TEMPORARY_LIVING_ASSIGNMENT_FAILURE,
  UPDATE_TEMPORARY_LIVING_ASSIGNMENT_REQUEST,
  UPDATE_TEMPORARY_LIVING_ASSIGNMENT_SUCCESS
} from '../types/temporaryLivingTypes';
import {
  DELETE_ADDRESS_SUCCESS,
  GET_ACTIVITY_LOG_REQUEST,
  GET_ADDRESS_SUCCESS,
  GET_ALL_AUTH_SERVICES_FAILURE,
  GET_ALL_AUTH_SERVICES_REQUEST,
  GET_ALL_AUTH_SERVICES_SUCCESS,
  GET_AUTHORIZATIONS_FAILURE,
  GET_AUTHORIZATIONS_REQUEST,
  GET_AUTHORIZATIONS_SUCCESS,
  GET_PENDING_AUTHS_FAILURE,
  GET_PENDING_AUTHS_REQUEST,
  GET_PENDING_AUTHS_SUCCESS,
  GET_AUTH_CLIENT_POLICIES_REQUEST,
  GET_AUTH_CLIENT_POLICIES_SUCCESS,
  GET_AUTH_DATE_SUMMARY_REQUEST,
  GET_AUTH_DATE_SUMMARY_SUCCESS,
  GET_AUTH_LIST_CLIENT_POLICIES_BY_CLIENT_SUCCESS,
  GET_AUTH_LIST_CLIENT_POLICIES_FAILURE,
  GET_AUTH_LIST_CLIENT_POLICIES_REQUEST,
  GET_AUTH_LIST_CLIENT_POLICIES_SUCCESS,
  GET_AUTH_SUMMARY_REQUEST,
  GET_AUTH_SUMMARY_FAILURE,
  GET_AUTH_SERVICES_REQUEST,
  GET_AUTH_SERVICES_SUCCESS,
  GET_AUTH_SUMMARY_SUCCESS,
  GET_AUTH_TEAM_SUCCESS,
  GET_COMMUNICATION_INFO_REQUEST,
  GET_COMMUNICATION_INFO_SUCCESS,
  GET_DEPARTURE_ADDRESS_SUCCESS,
  GET_DESTINATION_ADDRESS_SUCCESS,
  GET_EMPLOYEE_INFO_REQUEST,
  GET_EMPLOYEE_INFO_SUCCESS,
  GET_FAMILY_PET_REQUEST,
  GET_FAMILY_PET_SUCCESS,
  GET_FAMILY_REQUEST,
  GET_FAMILY_SUCCESS,
  GET_FINANCE_AND_TAX_REQUEST,
  GET_FINANCE_AND_TAX_SUCCESS,
  GET_SO_INFO_REQUEST,
  GET_SO_INFO_SUCCESS,
  GET_USER_SETTINGS_REQUEST,
  GET_USER_SETTINGS_SUCCESS,
  POST_ADDRESS_SUCCESS,
  POST_AUTH_CLIENT_POLICIES_SUCCESS,
  POST_AUTH_DATE_SUMMARY_SUCCESS,
  POST_AUTH_SERVICES_SUCCESS,
  POST_AUTH_TEAM_SUCCESS,
  POST_COMMUNICATION_INFO_SUCCESS,
  POST_DEPARTURE_ADDRESS_SUCCESS,
  POST_DESTINATION_ADDRESS_SUCCESS,
  POST_EMPLOYEE_INFO_SUCCESS,
  POST_FAMILY_PET_SUCCESS,
  POST_FAMILY_SUCCESS,
  POST_FINANCE_AND_TAX_SUCCESS,
  POST_SO_INFO_SUCCESS,
  POST_USER_SETTINGS_SUCCESS,
  SET_AUTH_ID,
  SET_LOADING_COMPLETE,
  UPDATE_ADDRESS_SUCCESS,
  UPDATE_AUTHORIZATIONS_SUCCESS,
  UPDATE_AUTH_CLIENT_POLICIES_SUCCESS,
  UPDATE_AUTH_DATE_SUMMARY_SUCCESS,
  UPDATE_AUTH_SERVICES_SUCCESS,
  UPDATE_AUTH_TEAM_SUCCESS,
  UPDATE_COMMUNICATION_INFO_SUCCESS,
  UPDATE_DEPARTURE_ADDRESS_SUCCESS,
  UPDATE_DESTINATION_ADDRESS_SUCCESS,
  UPDATE_EMPLOYEE_INFO_SUCCESS,
  UPDATE_FAMILY_DATA,
  UPDATE_FAMILY_PET_DATA,
  UPDATE_FAMILY_PET_SUCCESS,
  UPDATE_FAMILY_SUCCESS,
  UPDATE_FINANCE_AND_TAX_SUCCESS,
  UPDATE_SO_INFO_SUCCESS,
  UPDATE_USER_SETTINGS_SUCCESS,
  GET_AUTH_TRIPS_SUCCESS,
  POST_AUTH_TRIP_SUCCESS,
  UPDATE_AUTH_TRIP_SUCCESS,
  DELETE_AUTH_TRIP_SUCCESS,
  GET_AUTHORIZATION_BANKING_SUCCESS,
  POST_AUTHORIZATION_BANKING_SUCCESS,
  UPDATE_AUTHORIZATION_BANKING_SUCCESS,
  DELETE_AUTHORIZATION_BANKING_SUCCESS,
  GET_AUTHORIZATION_AREA_TOUR_SUCCESS,
  UPDATE_AUTHORIZATION_AREA_TOUR_SUCCESS,
  POST_AUTHORIZATION_AREA_TOUR_SUCCESS,
  GET_AUTHORIZATION_COMMENTS_SUCCESS,
  POST_AUTHORIZATION_COMMENTS_SUCCESS,
  UPDATE_AUTHORIZATION_COMMENTS_SUCCESS,
  DELETE_AUTHORIZATION_COMMENTS_SUCCESS,
  GET_AUTHORIZATION_SENT_TEMPLATES_SUCCESS,
  POST_AUTH_COMMENTS_ATTACHMENT_SUCCESS,
  UPDATE_AUTH_COMMENTS_ATTACHMENT_SUCCESS,
  DELETE_AUTH_COMMENTS_ATTACHMENT_SUCCESS,
  GET_FILE_TASKS_REQUEST,
  GET_FILE_TASKS_SUCCESS,
  GET_FILE_TASKS_FAILURE,
  CREATE_FILE_TASK_REQUEST,
  CREATE_FILE_TASK_SUCCESS,
  CREATE_FILE_TASK_FAILURE,
  GET_AUTH_SUMMARY_ADDRESS_SUCCESS,
  GET_AUTH_SUMMARY_ADDRESS_REQUEST,
  GET_AUTH_SUMMARY_ADDRESS_FAILURE
} from '../types/authorizationTypes';
import { UPDATE_TASK_SUCCESS } from 'modules/dashboard/types';
import {
  GET_ALL_BROKER_AGENTS_FAILURE,
  GET_ALL_BROKER_AGENTS_REQUEST,
  GET_ALL_BROKER_AGENTS_SUCCESS,
  GET_EXPENSE_CODES_BY_CLIENT_ID_SUCCESS,
  GET_EXPENSE_CODES_SUCCESS,
  GET_INSPECTORS_FAILURE,
  GET_INSPECTORS_REQUEST,
  GET_INSPECTORS_SUCCESS,
  GET_TAX_POLICIES_FAILURE,
  GET_TAX_POLICIES_REQUEST,
  GET_TAX_POLICIES_SUCCESS,
  GET_TITLE_REP_FAILURE,
  GET_TITLE_REP_REQUEST,
  GET_TITLE_REP_SUCCESS,
  GET_VENDORS_SUCCESS,
  GET_VENDOR_CONTACT_SUCCESS,
  GET_VENDOR_DOCUMENTS_SUCCESS,
  UPDATE_VENDOR_DETAILS_SUCCESS,
  GET_VENDOR_NOTES_SUCCESS,
  GET_VENDOR_BANKING_INFO_BY_VENDOR_ID_SUCCESS,
  GET_VENDOR_HISTORY_SUCCESS,
  GET_VENDOR_DETAILS_SUCCESS,
  SET_VENDOR_ID,
  POST_VENDOR_CONTACT_SUCCESS,
  UPDATE_VENDOR_CONTACT_SUCCESS,
  DELETE_VENDOR_CONTACT_SUCCESS,
  POST_VENDOR_DOCUMENT_SUCCESS,
  UPDATE_VENDOR_DOCUMENT_SUCCESS,
  DELETE_VENDOR_DOCUMENT_SUCCESS,
  POST_VENDOR_BANKING_INFO_SUCCESS,
  UPDATE_VENDOR_BANKING_INFO_SUCCESS,
  DELETE_VENDOR_BANKING_INFO_SUCCESS
} from '../types/dataManagementTypes';
import {
  GET_ALL_CANDIDATE_TRIPS_SUCCESS,
  GET_CANDIDATE_SERVICES_SUCCESS,
  GET_COST_ESTIMATES_SUCCESS,
  POST_CANDIDATE_SERVICES_SUCCESS,
  POST_CANDIDATE_TRIP_SUCCESS,
  POST_COST_ESTIMATES_SUCCESS,
  UPDATE_CANDIDATE_SERVICES_SUCCESS,
  UPDATE_CANDIDATE_TRIP_SUCCESS,
  UPDATE_COST_ESTIMATES_SUCCESS,
  GET_TRAVEL_BOOKING_REQUESTS_BY_AUTH_SUCCESS,
  UPDATE_TRAVEL_BOOKING_REQUESTS_SUCCESS
} from '../types/canidateTripTypes';
import {
  DELETE_CREDIT_SUCCESS,
  DELETE_EQUITY_SUCCESS,
  DELETE_TAX_SUCCESS,
  GET_ALL_HOMESALE_RESALE_OFFER_SUCCESS,
  GET_APPRAISALS_SUCCESS,
  GET_BUYOUT_SUCCESS,
  GET_CREDIT_SUCCESS,
  GET_EQUITY_SUCCESS,
  GET_HOMESALE_INFO_SUCCESS,
  GET_INSPECTIONS_SUCCESS,
  GET_LISTINGS_SUCCESS,
  GET_SPREAD_SELECTION_SUCCESS,
  GET_TAX_SUCCESS,
  POST_CREDIT_SUCCESS,
  POST_EQUITY_SUCCESS,
  POST_BUYOUT_SUCCESS,
  POST_HOMESALE_INFO_SUCCESS,
  POST_HOMESALE_RESALE_OFFER_SUCCESS,
  POST_INSPECTIONS_SUCCESS,
  POST_LISTINGS_SUCCESS,
  POST_TAX_SUCCESS,
  UPDATE_APPRAISALS_SUCCESS,
  UPDATE_BUYOUT_SUCCESS,
  UPDATE_CREDIT_SUCCESS,
  UPDATE_EQUITY_SUCCESS,
  UPDATE_HOMESALE_INFO_SUCCESS,
  UPDATE_HOMESALE_PROPERTY_INFO_SUCCESS,
  UPDATE_HOMESALE_RESALE_OFFER_SUCCESS,
  UPDATE_INSPECTIONS_STATE,
  UPDATE_INSPECTIONS_SUCCESS,
  UPDATE_LISTINGS_SUCCESS,
  UPDATE_SPREAD_SELECTION_SUCCESS,
  UPDATE_TAX_SUCCESS,
  GET_HOMESALE_MORTGAGE_INFO_SUCCESS,
  UPDATE_HOMESALE_MORTGAGE_INFO_SUCCESS,
  POST_HOMESALE_MORTGAGE_INFO_SUCCESS,
  DELETE_HOMESALE_MORTGAGE_INFO_SUCCESS,
  GET_APPRAISALS_PREFERENCES_SUCCESS,
  POST_APPRAISALS_PREFERENCES_SUCCESS,
  UPDATE_APPRAISALS_PREFERENCES_SUCCESS
} from '../types/homesaleTypes';
import {
  DELETE_AUTH_OFFER_HISTORY_LIST_SUCCESS,
  GET_AUTH_DESTINATION_ESTIMATED_DATES_SUCCESS,
  GET_AUTH_DESTINATION_SERVICES_SUCCESS,
  GET_AUTH_OFFER_HISTORY_LIST_SUCCESS,
  POST_AUTH_OFFER_HISTORY_LIST_SUCCESS,
  UPDATE_AUTH_DESTINATION_SERVICES_BUYER_SUCCESS,
  UPDATE_AUTH_DESTINATION_ESTIMATED_DATES_SUCCESS,
  UPDATE_AUTH_DESTINATION_SERVICES_RENTER_SUCCESS,
  UPDATE_AUTH_OFFER_HISTORY_LIST_SUCCESS
} from '../types/destinationServiceTypes';
import {
  GET_AUTH_TAX_ASSISTANCE_SUCCESS,
  GET_TAX_POLICIES_BY_CLIENT_SUCCESS,
  POST_AUTH_TAX_ASSISTANCE_SUCCESS,
  UPDATE_AUTH_TAX_ASSISTANCE_SUCCESS
} from '../types/taxAssistanceTypes';
import {
  DELETE_HHG_VEHICLES_SUCCESS,
  GET_HHG_ESTIMATES_SUCCESS,
  GET_HHG_ITEMS_SUCCESS,
  GET_HHG_MOVING_DATE_SUCCESS,
  GET_HHG_SEGMENTS_SUCCESS,
  GET_HHG_VEHICLES_SUCCESS,
  POST_HHG_SEGMENT_SUCCESS,
  POST_HHG_VEHICLES_SUCCESS,
  UPDATE_HHG_ESTIMATE_SUCCESS,
  UPDATE_HHG_SEGMENT_SUCCESS,
  UPDATE_HHG_VEHICLES_SUCCESS,
  POST_HHG_ESTIMATE_SUCCESS
} from '../types/houseHoldGoodsTypes';
import handleAuthorizationReducer from './authorizations.reducer';
import handleCanidateTripsReducer from './canidateTrip.reducer';
import handleDataManagementReducer from './dataManagement.reducer';
import handleDestinationServiceReducer from './destinationService.reducer';
import handleGlobalReducer from './global.reducer';
import handleHomesaleReducer from './homesale.reducer';
import handleHouseHoldGoodsReducer from './houseHoldGoods.reducer';
import handleTaxAssistanceReducer from './taxAssistance.reducer';
import handleTemporaryLivingReducer from './temporaryLiving.reducer';
import produce from 'immer';
import handleCommentsAndNotesReducer from './commentAndNotes.reducer';
import {
  GET_SURVEY_QUESTION_RESPONSES_BY_AUTH_SUCCESS,
  GET_SURVEY_QUESTIONS_SUCCESS,
  POST_TRANSFEREE_SURVEY_SUCCESS
} from 'modules/surveys/surveys.types';
import handleSurveyResponsesReducer from './surveyResponses.reducer';
import { GET_APPROVED_LINEITEM_SUMMARIES_SUCCESS, GET_EXPENSE_BY_AUTHORIZATION_SUCCESS } from 'modules/expenses/store/types';
import { POST_VENDORS_SUCCESS } from 'modules/authorizations/types';

const initialState = {
  allServices: null,
  authorizationSummaries: null,
  authorizationSummariesLoading: false,
  pendingAuthSummaries: null,
  pendingAuthSummariesLoading: false,
  allServicesLoading: false,
  authorizationDetails: {},
  clientPolicies: null,
  clientPoliciesLoading: false,
  currentAuthId: null,
  isLoading: false,
  taxPolicies: null,
  taxPoliciesLoading: false,
  brokerAgents: null,
  brokerAgentsLoading: false,
  vendors: null,
  vendorDetails: {},
  currentVendorId: null,
  vendorAuthNotes: null,
  isInspectorsLoading: false,
  titleReps: null,
  isTitleRepIsLoading: false,
  vendorHistory: null
};

export default produce((draft = initialState, action) => {
  switch (action.type) {
    case GET_AUTHORIZATIONS_REQUEST:
    case GET_PENDING_AUTHS_REQUEST:
    case GET_ALL_AUTH_SERVICES_REQUEST:
    case GET_EMPLOYEE_INFO_REQUEST:
    case GET_SO_INFO_REQUEST:
    case GET_AUTH_DATE_SUMMARY_REQUEST:
    case GET_COMMUNICATION_INFO_REQUEST:
    case GET_FINANCE_AND_TAX_REQUEST:
    case GET_AUTH_CLIENT_POLICIES_REQUEST:
    case GET_AUTH_SERVICES_REQUEST:
    case GET_USER_SETTINGS_REQUEST:
    case GET_AUTH_SUMMARY_REQUEST:
    case GET_AUTH_SUMMARY_FAILURE:
    case GET_FAMILY_REQUEST:
    case GET_FAMILY_PET_REQUEST:
    case GET_AUTHORIZATIONS_FAILURE:
    case GET_AUTHORIZATIONS_SUCCESS:
    case GET_PENDING_AUTHS_FAILURE:
    case GET_PENDING_AUTHS_SUCCESS:
    case GET_ALL_AUTH_SERVICES_FAILURE:
    case GET_ALL_AUTH_SERVICES_SUCCESS:
    case SET_AUTH_ID:
    case GET_USER_SETTINGS_SUCCESS:
    case SET_LOADING_COMPLETE:
    case GET_AUTH_SUMMARY_SUCCESS:
    case GET_EMPLOYEE_INFO_SUCCESS:
    case GET_SO_INFO_SUCCESS:
    case GET_COMMUNICATION_INFO_SUCCESS:
    case GET_FINANCE_AND_TAX_SUCCESS:
    case GET_AUTH_CLIENT_POLICIES_SUCCESS:
    case GET_AUTH_SERVICES_SUCCESS:
    case UPDATE_SO_INFO_SUCCESS:
    case UPDATE_EMPLOYEE_INFO_SUCCESS:
    case UPDATE_COMMUNICATION_INFO_SUCCESS:
    case UPDATE_FINANCE_AND_TAX_SUCCESS:
    case UPDATE_AUTH_CLIENT_POLICIES_SUCCESS:
    case UPDATE_AUTH_SERVICES_SUCCESS:
    case UPDATE_USER_SETTINGS_SUCCESS:
    case POST_EMPLOYEE_INFO_SUCCESS:
    case POST_SO_INFO_SUCCESS:
    case POST_AUTH_SERVICES_SUCCESS:
    case GET_AUTH_DATE_SUMMARY_SUCCESS:
    case UPDATE_AUTH_DATE_SUMMARY_SUCCESS:
    case POST_AUTH_DATE_SUMMARY_SUCCESS:
    case POST_COMMUNICATION_INFO_SUCCESS:
    case POST_FINANCE_AND_TAX_SUCCESS:
    case POST_AUTH_CLIENT_POLICIES_SUCCESS:
    case GET_DEPARTURE_ADDRESS_SUCCESS:
    case GET_DESTINATION_ADDRESS_SUCCESS:
    case UPDATE_DEPARTURE_ADDRESS_SUCCESS:
    case POST_DEPARTURE_ADDRESS_SUCCESS:
    case UPDATE_DESTINATION_ADDRESS_SUCCESS:
    case POST_DESTINATION_ADDRESS_SUCCESS:
    case GET_AUTH_LIST_CLIENT_POLICIES_REQUEST:
    case GET_AUTH_LIST_CLIENT_POLICIES_SUCCESS:
    case GET_AUTH_LIST_CLIENT_POLICIES_FAILURE:
    case GET_AUTH_TEAM_SUCCESS:
    case UPDATE_AUTH_TEAM_SUCCESS:
    case POST_AUTH_TEAM_SUCCESS:
    case POST_USER_SETTINGS_SUCCESS:
    case GET_ACTIVITY_LOG_REQUEST:
    case GET_FAMILY_SUCCESS:
    case UPDATE_FAMILY_SUCCESS:
    case POST_FAMILY_SUCCESS:
    case UPDATE_FAMILY_DATA:
    case GET_FAMILY_PET_SUCCESS:
    case UPDATE_FAMILY_PET_SUCCESS:
    case POST_FAMILY_PET_SUCCESS:
    case UPDATE_FAMILY_PET_DATA:
    case GET_AUTH_LIST_CLIENT_POLICIES_BY_CLIENT_SUCCESS:
    case UPDATE_AUTHORIZATIONS_SUCCESS:
    case GET_ADDRESS_SUCCESS:
    case UPDATE_ADDRESS_SUCCESS:
    case DELETE_ADDRESS_SUCCESS:
    case POST_ADDRESS_SUCCESS:
    case GET_AUTH_TRIPS_SUCCESS:
    case POST_AUTH_TRIP_SUCCESS:
    case UPDATE_AUTH_TRIP_SUCCESS:
    case DELETE_AUTH_TRIP_SUCCESS:
    case GET_AUTHORIZATION_BANKING_SUCCESS:
    case POST_AUTHORIZATION_BANKING_SUCCESS:
    case UPDATE_AUTHORIZATION_BANKING_SUCCESS:
    case DELETE_AUTHORIZATION_BANKING_SUCCESS:
    case POST_TRANSFEREE_SURVEY_SUCCESS:
    case GET_EXPENSE_BY_AUTHORIZATION_SUCCESS:
    case GET_APPROVED_LINEITEM_SUMMARIES_SUCCESS:
    case GET_AUTHORIZATION_SENT_TEMPLATES_SUCCESS:
    case GET_AUTH_SUMMARY_ADDRESS_REQUEST:
    case GET_AUTH_SUMMARY_ADDRESS_SUCCESS:
    case GET_AUTH_SUMMARY_ADDRESS_FAILURE:
      handleAuthorizationReducer(draft, action);
      break;

    case GET_ALL_BROKER_AGENTS_REQUEST:
    case GET_ALL_BROKER_AGENTS_SUCCESS:
    case GET_ALL_BROKER_AGENTS_FAILURE:
    case GET_TAX_POLICIES_REQUEST:
    case GET_TAX_POLICIES_FAILURE:
    case GET_TAX_POLICIES_SUCCESS:
    case GET_VENDORS_SUCCESS:
    case GET_VENDOR_CONTACT_SUCCESS:
    case GET_VENDOR_DOCUMENTS_SUCCESS:
    case GET_VENDOR_BANKING_INFO_BY_VENDOR_ID_SUCCESS:
    case GET_INSPECTORS_REQUEST:
    case GET_INSPECTORS_SUCCESS:
    case GET_INSPECTORS_FAILURE:
    case GET_EXPENSE_CODES_SUCCESS:
    case GET_EXPENSE_CODES_BY_CLIENT_ID_SUCCESS:
    case GET_TITLE_REP_REQUEST:
    case GET_TITLE_REP_SUCCESS:
    case GET_TITLE_REP_FAILURE:
    case GET_VENDOR_NOTES_SUCCESS:
    case GET_VENDOR_HISTORY_SUCCESS:
    case GET_VENDOR_DETAILS_SUCCESS:
    case UPDATE_VENDOR_DETAILS_SUCCESS:
    case SET_VENDOR_ID:
    case POST_VENDOR_CONTACT_SUCCESS:
    case UPDATE_VENDOR_CONTACT_SUCCESS:
    case DELETE_VENDOR_CONTACT_SUCCESS:
    case POST_VENDOR_DOCUMENT_SUCCESS:
    case UPDATE_VENDOR_DOCUMENT_SUCCESS:
    case DELETE_VENDOR_DOCUMENT_SUCCESS:
    case POST_VENDOR_BANKING_INFO_SUCCESS:
    case UPDATE_VENDOR_BANKING_INFO_SUCCESS:
    case DELETE_VENDOR_BANKING_INFO_SUCCESS:
    case POST_VENDORS_SUCCESS:
      handleDataManagementReducer(draft, action);
      break;

    case UPDATE_AUTH_TAX_ASSISTANCE_SUCCESS:
    case POST_AUTH_TAX_ASSISTANCE_SUCCESS:
    case GET_AUTH_TAX_ASSISTANCE_SUCCESS:
    case GET_TAX_POLICIES_BY_CLIENT_SUCCESS:
      handleTaxAssistanceReducer(draft, action);
      break;

    case UPDATE_AUTH_DESTINATION_SERVICES_BUYER_SUCCESS:
    case GET_AUTH_DESTINATION_ESTIMATED_DATES_SUCCESS:
    case UPDATE_AUTH_DESTINATION_ESTIMATED_DATES_SUCCESS:
    case GET_AUTH_DESTINATION_SERVICES_SUCCESS:
    case GET_AUTH_OFFER_HISTORY_LIST_SUCCESS:
    case UPDATE_AUTH_OFFER_HISTORY_LIST_SUCCESS:
    case POST_AUTH_OFFER_HISTORY_LIST_SUCCESS:
    case DELETE_AUTH_OFFER_HISTORY_LIST_SUCCESS:
    case UPDATE_AUTH_DESTINATION_SERVICES_RENTER_SUCCESS:
      handleDestinationServiceReducer(draft, action);
      break;

    case GET_AUTH_PETS_SUCCESS:
    case POST_AUTH_PETS_SUCCESS:
    case GET_TEMPORARY_LIVING_ASSIGNMENT_SUCCESS:
    case UPDATE_TEMPORARY_LIVING_ASSIGNMENT_SUCCESS:
    case DELETE_TEMPORARY_LIVING_ASSIGNMENT_SUCCESS:
    case POST_TEMPORARY_LIVING_ASSIGNMENT_SUCCESS:
    case POST_TEMPORARY_LIVING_ASSIGNMENT_REQUEST:
    case UPDATE_TEMPORARY_LIVING_ASSIGNMENT_REQUEST:
    case POST_TEMPORARY_LIVING_ASSIGNMENT_FAILURE:
    case UPDATE_TEMPORARY_LIVING_ASSIGNMENT_FAILURE:
    case GET_AUTH_PETS_FAILURE:
    case GET_TEMPORARY_LIVING_ASSIGNMENT_FAILURE:
    case POST_AUTH_PETS_FAILURE:
    case DELETE_TEMPORARY_LIVING_ASSIGNMENT_FAILURE:
    case GET_TEMPORARY_LIVING_ASSIGNMENT_REQUEST:
    case GET_AUTH_PETS_REQUEST:
    case POST_AUTH_PETS_REQUEST:
    case DELETE_TEMPORARY_LIVING_ASSIGNMENT_REQUEST:
      handleTemporaryLivingReducer(draft, action);
      break;

    case GET_HHG_SEGMENTS_SUCCESS:
    case UPDATE_HHG_SEGMENT_SUCCESS:
    case POST_HHG_SEGMENT_SUCCESS:
    case GET_HHG_MOVING_DATE_SUCCESS:
    case GET_HHG_ITEMS_SUCCESS:
    case GET_HHG_ESTIMATES_SUCCESS:
    case UPDATE_HHG_ESTIMATE_SUCCESS:
    case GET_HHG_VEHICLES_SUCCESS:
    case UPDATE_HHG_VEHICLES_SUCCESS:
    case POST_HHG_VEHICLES_SUCCESS:
    case DELETE_HHG_VEHICLES_SUCCESS:
    case POST_HHG_ESTIMATE_SUCCESS:
      handleHouseHoldGoodsReducer(draft, action);
      break;

    case GET_GLOBAL_INFO_SUCCESS:
    case UPDATE_GLOBAL_INFO_SUCCESS:
    case POST_GLOBAL_INFO_SUCCESS:
    case GET_ASSIGNMENT_TRIPS_SUCCESS:
    case GET_ASSIGNMENT_EXTENSIONS_SUCCESS:
    case GET_GLOBAL_DESTINATION_SERVICES_SUCCESS:
    case GET_GLOBAL_LANGUAGE_TRAINING_SUCCESS:
    case GET_GLOBAL_INTERNATIONAL_SCHOOLING_SUCCESS:
    case POST_GLOBAL_DESTINATION_SERVICES_SUCCESS:
    case POST_GLOBAL_LANGUAGE_TRAINING_SUCCESS:
    case POST_GLOBAL_INTERNATIONAL_SCHOOLING_SUCCESS:
    case UPDATE_GLOBAL_DESTINATION_SERVICES_SUCCESS:
    case UPDATE_GLOBAL_LANGUAGE_TRAINING_SUCCESS:
    case UPDATE_GLOBAL_INTERNATIONAL_SCHOOLING_SUCCESS:
    case DELETE_GLOBAL_DESTINATION_SERVICES_SUCCESS:
    case DELETE_GLOBAL_LANGUAGE_TRAINING_SUCCESS:
    case DELETE_GLOBAL_INTERNATIONAL_SCHOOLING_SUCCESS:
    case GET_GLOBAL_PROPERTY_MANAGEMENT_SUCCESS:
    case PUT_GLOBAL_PROPERTY_MANAGEMENT_HOME_SUCCESS:
    case PUT_GLOBAL_PROPERTY_MANAGEMENT_HOST_SUCCESS:
    case POST_GLOBAL_PROPERTY_MANAGEMENT_HOME_SUCCESS:
    case DELETE_GLOBAL_PROPERTY_MANAGEMENT_HOME_SUCCESS:
    case POST_GLOBAL_PROPERTY_MANAGEMENT_HOME_TENANT_SUCCESS:
    case PUT_GLOBAL_PROPERTY_MANAGEMENT_HOME_TENANT_SUCCESS:
    case DELETE_GLOBAL_PROPERTY_MANAGEMENT_HOME_TENANT_SUCCESS:
      handleGlobalReducer(draft, action);
      break;

    case GET_HOMESALE_INFO_SUCCESS:
    case UPDATE_HOMESALE_INFO_SUCCESS:
    case UPDATE_HOMESALE_PROPERTY_INFO_SUCCESS:
    case POST_HOMESALE_INFO_SUCCESS:
    case GET_APPRAISALS_SUCCESS:
    case UPDATE_APPRAISALS_SUCCESS:
    case GET_INSPECTIONS_SUCCESS:
    case UPDATE_INSPECTIONS_SUCCESS:
    case POST_INSPECTIONS_SUCCESS:
    case UPDATE_INSPECTIONS_STATE:
    case GET_LISTINGS_SUCCESS:
    case UPDATE_LISTINGS_SUCCESS:
    case POST_LISTINGS_SUCCESS:
    case GET_ALL_HOMESALE_RESALE_OFFER_SUCCESS:
    case UPDATE_HOMESALE_RESALE_OFFER_SUCCESS:
    case POST_HOMESALE_RESALE_OFFER_SUCCESS:
    case GET_EQUITY_SUCCESS:
    case UPDATE_EQUITY_SUCCESS:
    case GET_TAX_SUCCESS:
    case GET_CREDIT_SUCCESS:
    case GET_SPREAD_SELECTION_SUCCESS:
    case UPDATE_SPREAD_SELECTION_SUCCESS:
    case POST_EQUITY_SUCCESS:
    case DELETE_EQUITY_SUCCESS:
    case UPDATE_TAX_SUCCESS:
    case POST_TAX_SUCCESS:
    case DELETE_TAX_SUCCESS:
    case UPDATE_CREDIT_SUCCESS:
    case POST_CREDIT_SUCCESS:
    case DELETE_CREDIT_SUCCESS:
    case GET_BUYOUT_SUCCESS:
    case POST_BUYOUT_SUCCESS:
    case UPDATE_BUYOUT_SUCCESS:
    case UPDATE_HOMESALE_MORTGAGE_INFO_SUCCESS:
    case POST_HOMESALE_MORTGAGE_INFO_SUCCESS:
    case DELETE_HOMESALE_MORTGAGE_INFO_SUCCESS:
    case GET_HOMESALE_MORTGAGE_INFO_SUCCESS:
    case GET_APPRAISALS_PREFERENCES_SUCCESS:
    case POST_APPRAISALS_PREFERENCES_SUCCESS:
    case UPDATE_APPRAISALS_PREFERENCES_SUCCESS:
      handleHomesaleReducer(draft, action);
      break;

    case GET_CANDIDATE_SERVICES_SUCCESS:
    case UPDATE_CANDIDATE_SERVICES_SUCCESS:
    case POST_CANDIDATE_SERVICES_SUCCESS:
    case GET_ALL_CANDIDATE_TRIPS_SUCCESS:
    case UPDATE_CANDIDATE_TRIP_SUCCESS:
    case POST_CANDIDATE_TRIP_SUCCESS:
    case GET_COST_ESTIMATES_SUCCESS:
    case UPDATE_COST_ESTIMATES_SUCCESS:
    case POST_COST_ESTIMATES_SUCCESS:
    case GET_TRAVEL_BOOKING_REQUESTS_BY_AUTH_SUCCESS:
    case UPDATE_TRAVEL_BOOKING_REQUESTS_SUCCESS:
    case GET_AUTHORIZATION_AREA_TOUR_SUCCESS:
    case UPDATE_AUTHORIZATION_AREA_TOUR_SUCCESS:
    case POST_AUTHORIZATION_AREA_TOUR_SUCCESS:
      handleCanidateTripsReducer(draft, action);
      break;

    case GET_AUTHORIZATION_COMMENTS_SUCCESS:
    case POST_AUTHORIZATION_COMMENTS_SUCCESS:
    case UPDATE_AUTHORIZATION_COMMENTS_SUCCESS:
    case DELETE_AUTHORIZATION_COMMENTS_SUCCESS:
    case POST_AUTH_COMMENTS_ATTACHMENT_SUCCESS:
    case UPDATE_AUTH_COMMENTS_ATTACHMENT_SUCCESS:
    case DELETE_AUTH_COMMENTS_ATTACHMENT_SUCCESS:
      handleCommentsAndNotesReducer(draft, action);
      break;

    case GET_SURVEY_QUESTION_RESPONSES_BY_AUTH_SUCCESS:
    case GET_SURVEY_QUESTIONS_SUCCESS:
      handleSurveyResponsesReducer(draft, action);
      break;

    case GET_FILE_TASKS_REQUEST:
      draft.isLoading = true;
      break;

    case GET_FILE_TASKS_SUCCESS:
      draft.isLoading = false;
      if (!draft.authorizationDetails[draft.currentAuthId]) draft.authorizationDetails[draft.currentAuthId] = {};
      draft.authorizationDetails[draft.currentAuthId].fileTasks = action.response;
      break;

    case GET_FILE_TASKS_FAILURE:
      draft.isLoading = false;
      if (!draft.authorizationDetails[draft.currentAuthId]) draft.authorizationDetails[draft.currentAuthId] = {};
      if (!draft.authorizationDetails[draft.currentAuthId].fileTasks) draft.authorizationDetails[draft.currentAuthId].fileTasks = [];
      break;

    case CREATE_FILE_TASK_REQUEST:
      break;

    case CREATE_FILE_TASK_SUCCESS:
      if (draft.authorizationDetails[draft.currentAuthId]?.fileTasks) {
        draft.authorizationDetails[draft.currentAuthId].fileTasks.push(action.response);
      }
      break;

    case CREATE_FILE_TASK_FAILURE:
      break;

    // Task updates go through the dashboard's updateTask action; keep the open file's task list in step with the saved row
    case UPDATE_TASK_SUCCESS:
      const fileTasks = draft.authorizationDetails[draft.currentAuthId]?.fileTasks;
      const updatedTaskIndex = fileTasks ? fileTasks.findIndex(t => t.taskId === action.response?.taskId) : -1;
      if (updatedTaskIndex !== -1) fileTasks[updatedTaskIndex] = action.response;
      break;

    default:
      break;
  }

  return draft;
}, initialState);
